// extracted by mini-css-extract-plugin
module.exports = {"bottomBar":"styles_bottomBar__1tmqT","seekbar":"styles_seekbar__3k7OU","controls":"styles_controls__33suu","columns":"styles_columns__13uJG"};